import { ReactNode } from "react";
import { LabelValue } from "@/types/common";

export interface ISlides {
  id: number;
  content: ReactNode;
}

export interface ITopic {
  handleNextTopic?: () => void;
  isPassed: boolean;
  setTestResults?: React.Dispatch<
    React.SetStateAction<
      Map<string, { score_percent: number; completed_at: string; id: string }>
    >
  >;
}

export interface ISecurityTopic {
  slides: Array<ISlides>;
  quizList: Array<IQuizList>;
  quizName: SecurityTopicEnum;
  isPassed: boolean;
  lastStep?: number;
  handleNextTopic?: () => void;
  setTestResults?: React.Dispatch<
    React.SetStateAction<
      Map<string, { score_percent: number; completed_at: string; id: string }>
    >
  >;
}

export interface IQuizList {
  name: string;
  question: string;
  options: Array<LabelValue>;
}

export enum SecurityTopicEnum {
  Phishing = "phishing",
  Password2Fa = "password2Fa",
  ConfidentialInfo = "confidentialInfo",
  PhysicalSecurity = "physicalSecurity",
  ThirdPartyLeakage = "thirdPartyLeakage",
  MobileThreats = "mobileThreats",
  EmployeeResponsibility = "employeeResponsibility",
}

export enum Answer {
  Correct = "true",
  Incorrect = "false",
}
